export default __webpack_public_path__ + "static/media/LOGO-instt.94a1525f.png";